import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const AlertIcon: React.FC<IconProps> = ({
  className = '',
  viewBox = '0 0 22 19',
  fill = colors.blueGrey,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={Styling.fullWidthStyle}
      role='img'
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Title text='Alert Error' />
      <Elements.Path
        fill={fill}
        d='M0 19h22L11 0zm12-3h-2v-2h2zm0-4h-2V8h2z'
        transition='fill 0.1s ease-in-out'
      />
    </Elements.Svg>
  );
};

export default AlertIcon;
